<template>
  <div id='DrTeam'>
        <div class='shelter' @click='close'></div>
        <img :src="logourl" alt="xjd logo" class="logo">
        <div class='DrTeamBox'>
            <img :src="Dr.informal_url" class="DrTeamImg" />
            <div class='DrTeamName'>{{Dr.member_name}}</div>
            <div class='DrTeamWork'>{{Dr.member_title}}</div>
            <div class='DrTeamYear'>{{Dr.member_exp}}年临床经验</div>
            <div class='DrTeamTitle'>{{Dr.member_introduction}}</div>
        </div>
        <div class="del"><img src="../assets/icon-close.png" @click='close'></div>
  </div>
</template>

<script>
export default {
  name: 'DrTeam',
  props: {
    Dr: Object,
    fn: Function
  },
  methods: {
   close() {
      if(this.fn){
        this.fn()
      }
   }
  },

}
</script>  

<style>
#DrTeam{
  width: 100vw;
  height: 90vh;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
}
.DrTeamBox{
      width: 80vw;
      height:70vh;
      background-color: #fff;
      position: absolute;
      left: 10vw;
      top:8vh;
      border-radius: 6px;
      text-align: left;
      overflow-y:auto;
    }
.DrTeamImg{
        width: 80vw;
        display: block;
      }
.DrTeamName,.DrTeamWork,.DrTeamYear,.DrTeamTitle{
        padding:0 5vw; 
        font-size: 3.5vw;
        color:#505050;
      }
.DrTeamName{
        height: 12vw;
        line-height: 12vw;
        font-weight: bold;
        color: #141414;
        font-size: 5vw;
}
.DrTeamYear{
  margin-bottom: 5vw;
}
.DrTeamTitle{
font-size: 3.6vw;
}

.del{
  position: absolute;
  top:80vh;
  width: 10vw;
  height: 10vw;
  left: 45vw;
 
}
.del img{
    width: 100%;
    height: 100%;
    display: block;
  }
.shelter{
      width: 100vw;
      height: 90vh;
      background-color: #000;
      opacity: 0.3;
  }
</style>